import { render } from "./DonorFormPayment.vue?vue&type=template&id=8325dbc2"
import script from "./DonorFormPayment.vue?vue&type=script&lang=js"
export * from "./DonorFormPayment.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/nce_go/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__